import * as React from "react";
import { useEffect, useState } from "react";
import EYLogoAndHelpUrl from "../EYLogoAndHelpUrl";
import ExcelTableRenderer from "./ExcelTableRenderer";
import { ServerSyncInfoSettings } from "../../helpers/common/ServerSyncInfoSettings";
import { DataAddInStateManager } from "../../helpers/common/DataAddInStateManager";
import _ = require("lodash");
import styled from "styled-components";
import ErrorSummary from "../common/error/ErrorSummary";
import { labels } from "../../util/utils";

function SummaryView(props: any) {
  const {
    engagementId,
    loadSummary,
    activeSheetName,
    configuration,
    activeSheetId,
    dataModel,
    engagementSelected,
    userDateTimeFormat,
    runOfflineMode,
    userLanguage,
    ldcVersioning,
  } = props;
  // Initialize individual state variables
  const [serverSyncInfo, setServerSyncInfo] = useState(new ServerSyncInfoSettings(activeSheetId, engagementId));
  const [errorMessage, setErrorMessage] = useState("");

  // Equivalent to componentDidMount
  useEffect(() => {
    downloadNow();
  }, []);

  const getNoofRecords = (data: any) => {
    let apiTemplate = configuration?.entityConfiguration?.apiTemplate;
    let dataAttributeName = apiTemplate?.get.dataAttributeName
      ? apiTemplate.get.dataAttributeName
      : configuration.entityConfiguration?.apiDataAttributeListName;
    let dataList = data;
    if (dataAttributeName && data) {
      dataList = dataList?.[dataAttributeName];
    }

    return dataList?.length;
  };

  const downloadNow = async (): Promise<void> => {
    let serverSyncSettings = new ServerSyncInfoSettings(activeSheetId, engagementId);
    if (loadSummary) {
      await loadViewFromPersistedServerSyncInfo(activeSheetName);
    } else {
      if (dataModel && dataModel.done) {
        serverSyncSettings.noOfRecordsDownloaded = getNoofRecords(dataModel?.response) ?? 0;
        serverSyncSettings.requestsDownloadedDate = dataModel.fetchedTimeStamp;
        serverSyncSettings.requestUploadedDate = null;
        serverSyncSettings.selectedEntityType = configuration.configurationType;
        serverSyncSettings.activeSheetName = activeSheetName;
        serverSyncSettings.engagementId = engagementId;
        serverSyncSettings.activeSheetId = activeSheetId;
        serverSyncSettings.engagementIdAndDescription = engagementSelected;
        serverSyncSettings.userLanguage = userLanguage;
        serverSyncSettings.engagementLDCVersion = ldcVersioning?.datacenterversion;
        serverSyncSettings.entitySelected = configuration.settings.entitySelected;
        await DataAddInStateManager.persistServerSyncInfoSettings(serverSyncSettings);
        setServerSyncInfo(serverSyncSettings);
      } else {
        setServerSyncInfo(serverSyncSettings);
      }
    }
  };

  const loadViewFromPersistedServerSyncInfo = async (engagementIdToLoad: string): Promise<void> => {
    let serverSyncSettings = await DataAddInStateManager.getPersistedServerSyncInfo(activeSheetId, activeSheetName);
    if (serverSyncSettings !== null) {
      setServerSyncInfo(serverSyncSettings);
    } else {
      console.log("Could not find the persisted settings for the engagement", engagementIdToLoad);
      setServerSyncInfo(serverSyncSettings);
    }
  };

  const callBackUploadDataToServer = async (errorMessage: string): Promise<string> => {
    setErrorMessage(errorMessage);
    return errorMessage;
  };

  // Render method
  const renderContent = () => {
    return (
      <StyledMainSection className="main-wrap body-wrap">
        <section className="body-wrap">
          <section className="body-section">
            <EYLogoAndHelpUrl />
            {errorMessage && (
              <ErrorSummary
                message={errorMessage}
                callBack={() => {
                  setErrorMessage("");
                }}
              ></ErrorSummary>
            )}
            <section className="label-value-main">
              {serverSyncInfo.engagementIdAndDescription && (
                <section className="label-value-wrap">
                  <span
                    className="engagement-name motif-body1-default-light"
                    title={serverSyncInfo.engagementIdAndDescription}
                  >
                    <section className="eng-label-engagement-name" title={labels.engagement}>
                      {labels.engagement}
                    </section>{" "}
                    <section className="eng-name" title={serverSyncInfo.engagementIdAndDescription}>
                      {serverSyncInfo.engagementIdAndDescription}
                    </section>
                  </span>
                </section>
              )}
              {serverSyncInfo?.entitySelected && (
                <section className="label-value-wrap">
                  <section className="module-label" title={labels.module}>
                    {labels.module}
                  </section>
                  <section className="eng-name" title={serverSyncInfo?.entitySelected}>
                    {serverSyncInfo?.entitySelected}
                </section>
              </section>)}
              {!props.configuration?.entityConfiguration?.hideSummaryDetails && (
                <>
                  {/* <section className="label-value-wrap">
                  <section className="eng-label" title={labels.numberOfRecords}>
                    {labels.numberOfRecords}
                  </section>
                  <section className="eng-val" title={serverSyncInfo.noOfRecordsDownloaded.toString()}>
                    {serverSyncInfo.noOfRecordsDownloaded}
                  </section>
                </section> */}
                  {/* <section className="label-value-wrap">
                  <section className="eng-label" title={labels.dowanloadedOn}>
                    {labels.dowanloadedOn}
                  </section>
                  <section
                    className="eng-val"
                    title={getFormattedDate(serverSyncInfo.requestsDownloadedDate, userDateTimeFormat).toLocaleString()}
                  >
                    {getFormattedDate(serverSyncInfo.requestsDownloadedDate, userDateTimeFormat).toLocaleString()}
                  </section>
                </section> */}
                </>
              )}
            </section>
          </section>
          <ExcelTableRenderer
            requestsModel={dataModel}
            engagementIdToRender={engagementId}
            activeSheetName={activeSheetName}
            loadExisting={loadSummary}
            callBackOnSaveToServer={callBackUploadDataToServer}
            configuration={configuration}
            activeSheetId={activeSheetId}
            userDateTimeFormat={userDateTimeFormat}
            runOfflineMode={runOfflineMode}
          ></ExcelTableRenderer>
          {/* </section> */}
          {/* <section className="refresh-back-btns"></section> */}
        </section>
      </StyledMainSection>
    );
  };
  return renderContent();
}

export default SummaryView;

const StyledMainSection = styled.section`
  height: 100%;
  .body-wrap {
    position: relative;
    flex-flow: column;
    display: flex;
    background-color: var(--neutrals-50);
    height: 100vh;
    overflow: auto;
    .label-value-main {
      color: var(--neutrals-900);
      line-height: normal;
    }
    .divider {
      border-top: solid 1px var(--neutrals-300);
      height: 1px;
      margin-top: var(--px-56);
      margin-bottom: var(--px-16);
    }

    .btns-wrap {
      margin: var(--px-10) 0;
    }
    .btn {
      margin-bottom: var(--px-12);
      &.secondary-btn {
        width: 30%;
        &:hover {
          cursor: pointer;
        }
      }

      &:last-child {
        margin-bottom: 0;
      }
      &.save-btn {
        margin-bottom: var(--px-10);
      }
      &.back-btn {
        margin-top: auto;
      }
    }
    .label-value-wrap {
      .engagement-name {
        margin-bottom: 0 !important;
        .eng-label-engagement-name {
          font-size: var(--px-12);
          font-weight: 700;
        }
      }
      .engagement-name {
        width: 100%;
        font-size: var(--px-12);
        font-weight: var(--fw-light);
        color: var(--neutrals-900);
      }
      .eng-val {
        margin-bottom: var(--spacing-small);
        font-size: var(--px-12);
      }
      .engagement-name {
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        display: inline-block;
        line-height: var(--px-20);
      }
      .module-label {
        font-size: var(--px-12);
        width: 100%;
        font-weight: 700;
        color: var(--neutrals-900);
        line-height: var(--px-20);
      }
      .eng-name {
        text-overflow: ellipsis !important;
        overflow: hidden;
        font-size: var(--px-12);
        font-weight: var(--fw-light);
        margin-bottom: var(--spacing-small);
      }
    }
    .get-spinner {
      margin: var(--px-64) 0;
      display: flex;
      justify-content: center;
    }
    .pop-spinner {
      margin: var(--px-80) 0;
    }
    .table-spinner {
      margin: var(--px-22) 0;
    }
    .body-section {
      padding: var(--spacing-medium) var(--spacing-x-large) var(--spacing-x-small) var(--spacing-x-large);
    }
  }
`;
